import './AttachmentIcon.scss';

import { SvgPaperclip, Icon } from '@tmapy/style-guide';

type AttachmentIconProps = {
  count: number;
};

export const AttachmentIcon: React.FC<AttachmentIconProps> = (props) => {
  return (
    <div className='dmx-attachmentIcon'>
      <Icon element={<SvgPaperclip />} size="med" />
      <span className='dmx-attachmentIcon--count'>{props.count}</span>
    </div>
  );
};
